module.exports = __webpack_public_path__ + "static/img/manual-49.ffc13b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-49.png
// module id = FRYk
// module chunks = 4